import type { FreelancerAvailability } from 'state/__generated__/tadaahAPI';
import { useApiOrganisationFreelancerAvailabilityRead } from 'state/__generated__/tadaahAPI';

type UseGetFreelancerAvailabilityType = {
  data: FreelancerAvailability[];
  error: string | undefined;
  isLoading: boolean;
};

const useGetFreelancerAvailability = (
  freelancerId: number,
  fromDate?: string,
  toDate?: string,
  fromTime?: string,
  toTime?: string,
): UseGetFreelancerAvailabilityType => {
  const { data, error, isLoading } =
    useApiOrganisationFreelancerAvailabilityRead(
      freelancerId.toString(),
      {
        from_date: fromDate || undefined,
        from_time: fromTime || undefined,
        to_date: toDate || undefined,
        to_time: toTime || undefined,
      },
      {
        query: {
          queryKey: 'organisation-freelancer-availability',
        },
      },
    );
  return { data: data?.data ?? [], error: error?.message, isLoading };
};

export default useGetFreelancerAvailability;
